<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<h1 class="calibre2" id="pgepubid00001">The Story of Porcelain</h1>
<p class="csmall">BY</p>
</div>
<div class="calibre1">
<h2 class="sigil_not_in_toc" id="pgepubid00003">SARA WARE BASSETT</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?792f81b2